import { watchUpdateAddressFromAxAddress } from './updateAddressFromAxAddress';

export const addressSagas = [watchUpdateAddressFromAxAddress()];
